import { JSX, type ReactNode } from "react";

import { Grid, Box } from "@mui/material";

import HorizontalScrollWrapper from "./HorizontalScrollWrapper";
import { scrollGridContainer } from "./infoBar.helper";
import MobileScrollSpacer from "./MobileScrollSpacer";

function ScrollGridInfoBar({ children, columns }: { children: ReactNode; columns?: number }): JSX.Element {
  return (
    <HorizontalScrollWrapper>
      <Box display='flex' alignItems='center' width='100%'>
        <MobileScrollSpacer />
        <Grid container spacing={2} columns={columns} display='flex' width='100%' flexWrap='nowrap' sx={scrollGridContainer}>
          {children}
        </Grid>
        <MobileScrollSpacer />
      </Box>
    </HorizontalScrollWrapper>
  );
}

ScrollGridInfoBar.defaultProps = {
  columns: 12,
};

export default ScrollGridInfoBar;
